import axios from "axios";

export const getNotificationDashboard = ({ userId, uen }) => {
  const requestUrl = `/data/notifications-dashboard`;

  let params = {
    userId: userId,
    uen: uen
  };

  return axios.get(requestUrl, {
    params
  });
};

export const getNotificationSlide = ({ userId, uen }) => {
  const requestUrl = `/data/notifications-slide`;

  let params = {
    userId: userId,
    uen: uen
  };

  return axios.get(requestUrl, {
    params
  });
};

export const closeNotification = ({ userId, uen, action }) => {
  const requestUrl = `/data/close-notification`;

  let formData = new FormData();
  formData.append("userId", userId);
  formData.append("uen", uen);
  formData.append("action", action);
  return axios.post(requestUrl, formData);
};

export const getNotificationDashboardCrossSharing = ({ userId, uen }) => {
  const requestUrl = `/data/notifications-shared-dashboards`;

  let params = {
    userId: userId,
    uen: uen
  };

  return axios.get(requestUrl, {
    params
  });
};

export const getNotificationSlideCrossSharing = ({ userId, uen }) => {
  const requestUrl = `/data/notifications-shared-slides`;

  let params = {
    userId: userId,
    uen: uen
  };

  return axios.get(requestUrl, {
    params
  });
};

export const getNotificationBalanceImported = ({ userId, uen }) => {
  const requestUrl = `/data/notifications-imported-balance`;

  let params = {
    userId: userId,
    uen: uen
  };

  return axios.get(requestUrl, {
    params
  });
};



// WEBPACK FOOTER //
// ./src/api/notification.js